import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

export interface ButtonPanelProps {
  children: ReactNode;
  className?: string;
}

export const ButtonPanel: FC<ButtonPanelProps> = ({ children, className }) => (
  <div className={classNames('d-flex flex-shrink-0 flex-column', className)}>{children}</div>
);

type ActionButtonProps = {
  label: IntlKey;
  color?: 'primary' | 'secondary' | 'discreet-secondary' | 'default' | 'info';
  isFlat?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  e2e?: string;
  icon?: string;
  className?: string;
};

export const ActionButton: FC<ActionButtonProps> = ({
  label,
  color,
  disabled = false,
  onClick,
  icon,
  e2e,
  className,
  isFlat = false,
}) => {
  const { formatMessage } = useIntl();
  const btnClassName = isFlat ? `btn-flat-${color}` : `btn-${color}`;
  return (
    <button
      type="button"
      disabled={disabled}
      className={classNames(`btn btn-xl ${btnClassName} m-1`, className)}
      onClick={onClick}
      data-e2e={e2e}
    >
      {formatMessage({ id: label })}
      {icon && <em className="icon ms-2">{icon}</em>}
    </button>
  );
};

export const ActionButtonSkeleton: FC = () => (
  <button type="button" disabled className="`btn btn-xl btn-discreet-secondary m-1">
    <Skeleton width="10em" />
  </button>
);
